import React from 'react';
import { getTheme } from '../../styles/theme';

const Types = {
    Add: 'add',
    Sub: 'sub',
    Remove: 'remove',
    Dollar: 'dollar',
    ChevronRight: 'chevronRight',
    ChevronLeft: 'chevronLeft'
};

const FormIcon = (props) => {

    const color = props.disabled ? getTheme().colorElementDisabled : getTheme().colorFormTitle;
    let icon;
    switch(props.type) {
        case Types.Dollar:
            icon = (
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.83327 9.41658C7.9416 8.92492 7.33327 8.41658 7.33327 7.62492C7.33327 6.71659 8.17493 6.08325 9.58327 6.08325C11.0666 6.08325 11.6166 6.79159 11.6666 7.83325H13.5083C13.4499 6.39992 12.5749 5.08325 10.8333 4.65825V2.83325H8.33327V4.63325C6.7166 4.98325 5.4166 6.03325 5.4166 7.64159C5.4166 9.56659 7.00827 10.5249 9.33327 11.0833C11.4166 11.5833 11.8333 12.3166 11.8333 13.0916C11.8333 13.6666 11.4249 14.5833 9.58327 14.5833C7.8666 14.5833 7.1916 13.8166 7.09993 12.8333H5.2666C5.3666 14.6583 6.73327 15.6833 8.33327 16.0249V17.8333H10.8333V16.0416C12.4583 15.7333 13.7499 14.7916 13.7499 13.0833C13.7499 10.7166 11.7249 9.90825 9.83327 9.41658Z" fill="black"/>
                </svg>
            );
            break;   
        case Types.ChevronRight:
            icon = (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.99997 6L8.58997 7.41L13.17 12L8.58997 16.59L9.99997 18L16 12L9.99997 6Z" fill={color}/>
                </svg>
            );
            break;
        case Types.ChevronLeft:
            icon = (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" fill={color}/>
                </svg>
            );
            break;    
        default:
            icon = null;
            break;        
    }

    return icon;
}

export default FormIcon;